import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../firebaseConfig';
import { getUserProfile } from '../services/authService';

const AuthRoute = ({ children, requiredRole = null }) => {
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setCurrentUser(user);
        const profile = await getUserProfile(user.uid);
        setUserRole(profile?.role || 'user');
      } else {
        setCurrentUser(null);
        setUserRole(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#0f172a', color: '#3b82f6', fontSize: '20px' }}>
        Verifying Session...
      </div>
    );
  }

  // Not logged in at all
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Logged in, but lacks required role (e.g., user trying to access /crm)
  if (requiredRole && userRole !== requiredRole) {
    // If they are just a user, send to user-portal
    if (userRole === 'user') {
      return <Navigate to="/user-portal" replace />;
    } else {
      return <Navigate to="/login" replace />;
    }
  }

  // Allow access
  return children;
};

export default AuthRoute;
